import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from 'stylesheets/components/badge.module';

export function Badge({ text, size, badgeBackgroundColor, elevated }) {
  const backgroundOverride = {
    backgroundColor: badgeBackgroundColor,
  };

  return (
    <div className={classNames(styles.badge, styles[size], { [styles.elevated]: elevated })} style={badgeBackgroundColor ? backgroundOverride : null}>
      {text}
    </div>
  );
}

Badge.propTypes = {
  text: PropTypes.string.isRequired,
  badgeBackgroundColor: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  elevated: PropTypes.bool,
};

Badge.defaultProps = {
  size: 'medium',
  elevated: false
};
